import gloo from './gloo.json';
import lacuna from './lacuna.json';
import wwworldcup from './wwworldcup.json';

export default {
  gloo,
  lacuna,
  wwworldcup,
}



// WEBPACK FOOTER //
// ./src/data/index.js